import React, { useState } from "react";
import css from "./DateRange.scss";
import { SingleDatePicker } from "react-dates";
import PropTypes from "prop-types";
import Moment from "moment";

const DateRange = props => {
  const [startDateFocused, setStartDateFocused] = useState(false);
  const [endDateFocused, setEndDateFocused] = useState(false);

  return (
    <div className={css['select-container']}>
      <div className={css['daterange-select']}>
        <label className={css['date-label']} htmlFor="start-date-select">Start Date</label>
          <div className={css['date-select']}>
            <SingleDatePicker
              date={props.startDate}
              onDateChange={date => props.setStartDate(date)}
              focused={startDateFocused}
              onFocusChange={({ focused }) => setStartDateFocused(focused)}
              id="start-date-select"
              showClearDate={true}
              readOnly={true}
              numberOfMonths={1}
              displayFormat="MM-DD-YYYY"
              placeholder="MM-DD-YYYY"
              showDefaultInputIcon
              inputIconPosition="after"
              small
              hideKeyboardShortcutsPanel
              openDirection="up"
            />
          </div>
      </div>
      <span className={css['to-date']}>to</span>
      <div className={css['daterange-select']}>
        <label htmlFor={"end-date-select"} className={css['date-label']}>End Date</label>
          <div className={css['date-select']}>
            <SingleDatePicker
              date={props.endDate}
              onDateChange={date => props.setEndDate(date)}
              focused={endDateFocused}
              onFocusChange={({ focused }) => setEndDateFocused(focused)}
              id="end-date-select"
              showClearDate={true}
              readOnly={true}
              numberOfMonths={1}
              displayFormat="MM-DD-YYYY"
              placeholder="MM-DD-YYYY"
              showDefaultInputIcon
              inputIconPosition="after"
              small
              keepOpenOnDateSelect={false}
              hideKeyboardShortcutsPanel
              openDirection="up"
              isOutsideRange={date => date.isBefore(props.startDate)}
            />
          </div>

      </div>
    </div>
  )
};

DateRange.propTypes = {
  startDate: PropTypes.instanceOf(Moment),
  setStartDate: PropTypes.func.isRequired,
  endDate: PropTypes.instanceOf(Moment),
  setEndDate: PropTypes.func.isRequired,
};

export default DateRange;
